/**
 * Añade el prefijo data:image a un string base64
 * La API devuelve las imágenes sin el prefijo, solo el base64
 */
export const addBase64Prefix = (base64String, mimeType = 'image/jpeg') => {
  if (!base64String) return null

  // Si ya tiene el prefijo, devolverlo tal cual
  if (base64String.startsWith('data:')) {
    return base64String
  }

  // Añadir el prefijo
  return `data:${mimeType};base64,${base64String}`
}

/**
 * Detecta el tipo MIME de una imagen por su extensión
 */
export const getMimeTypeFromExtension = (extension) => {
  const mimeTypes = {
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.png': 'image/png',
    '.gif': 'image/gif',
    '.webp': 'image/webp',
  }

  return mimeTypes[extension?.toLowerCase()] || 'image/jpeg'
}
